import {createGlobalStyle} from 'styled-components';
import outlineNeon from '../media/outlineNeon.svg'
import outlinePink from '../media/outlinePink.svg'
import outlineNeonTwo from '../media/outlineNeonTwo.svg'
import outlinePinkTwo from '../media/outlinePinkTwo.svg'
import cursorPointNeon from '../media/cursorPointNeon.svg'
import cursorPointPink from '../media/cursorPointPink.svg'
import cursorAutoNeon from '../media/cursorAutoNeon.svg'
import cursorAutoPink from '../media/cursorAutoPink.svg'
import cursorAutoNeonTwo from '../media/cursorAutoNeonTwo.svg'
import cursorAutoPinkTwo from '../media/cursorAutoPinkTwo.svg'


export const neon = {
    main: '#03212A', 
    mainOne: '#03B5CE',
    titleOne: '#FACB76', 
    titleTwo: '#FF61B1',
    titleThree: '#3B55CE',
    // paraOne: '#F7F7F7',
    // paraOne: '#F5F5F5',
    paraOne: '#FFFAF1',
    // paraOne: '#037A90',
    paraTwo: '#393333',
    paraThree:'#037A90',
    eOne: '#0B2C36',
    eTwo: '#00C2BA',
    correctGreen: '#1ED155',
    wrongRed: '#D73E5E',
    sketchColourG: '0',
    r: 245,
    g: 115,
    b: 57,
    postR:152,
    postG:14,
    postB:14,
    outline: `${outlineNeon}`,
    outlineTwo: `${outlineNeonTwo}`,
    cursorPoint: `${cursorPointNeon}`,
    cursorAuto: `${cursorAutoNeon}`,
    cursorAutoTwo: `${cursorAutoNeonTwo}`,
    bubbleLink: 'https://editor.p5js.org/almamlalma@icloud.com/embed/8HQc7FO_r'
}

export const pink = {
    main: '#FFC6C7',
    mainOne: '#E44985',
    titleOne: '#BD245F',
    titleTwo: '#FF8BA7',
    titleThree: '#D66086',
    paraOne: '#393333',
    // paraTwo: '#F7F7F7',
    paraTwo: '#F5F5F5',
    paraThree: '#E37FA9',
    eOne: '#FFBDC2',
    // eTwo: '#D66086',
    eTwo: '#BD245F',
    correctGreen: '#26653A',
    wrongRed: '#D73E5E',
    sketchColourG: '217',
    r: 240,
    g: 143,
    b: 143,
    postR:204,
    postG:50,
    postB:50,
    outline: `${outlinePink}`,
    outlineTwo: `${outlinePinkTwo}`,
    cursorPoint: `${cursorPointPink}`,
    cursorAuto: `${cursorAutoPink}`,
    cursorAutoTwo: `${cursorAutoPinkTwo}`,
    bubbleLink: 'https://editor.p5js.org/almamlalma@icloud.com/embed/1QhSIL4cA',
}


export const GlobalStyles = createGlobalStyle`


//General

body {
    cursor: url(${({theme})=>theme.cursorAuto}), auto;
}
.main {
    background-color: ${({theme})=>theme.main}
}

.mainOne {
    background-color: ${({theme})=>theme.mainOne}
}

.titleOne {
    background-color: ${({theme})=>theme.titleOne}
}

.titleOneText {
    color: ${({theme})=>theme.titleOne}
}
.titleTwoText {
    color: ${({theme})=>theme.titleTwo}
}

.titleTwo {
    background-color: ${({theme})=>theme.titleTwo}
}

.mainOneText {
    background-color: ${({theme})=>theme.main};
    color: ${({theme})=>theme.mainOne}
}

.paraOneText {
    color: ${({theme})=>theme.paraOne};
    border: ${({theme})=>theme.titleOne} solid 1px;
}

.titleThreeText {
    color: ${({theme})=>theme.titleThree};
}

.eTwoText{
    color: ${({theme})=>theme.eTwo};
}

.buttonOne {
    border-width: 3px;
    border-color: ${({theme})=>theme.titleOne};
    border-style: dashed solid;
    animation: flow 5s ease-in-out infinite;
    background: linear-gradient(-60deg, ${({theme})=>theme.titleOne},${({theme})=>theme.titleTwo}, ${({theme})=>theme.titleOne}, ${({theme})=>theme.titleTwo});
    background-size: 300%;
    background-clip: text;
    -webkit-background-clip: text;
    text-fill-color: transparent;
    -webkit-text-fill-color: transparent;
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
    &:hover {
        border-style: solid;
        border-color: ${({theme})=>theme.titleTwo};
        }
}

@keyframes flow {    
    0% 
        {background-position: 0 50%; }
    
    50% 
        {background-position: 100% 50%;}
    
    100% 
        {background-position: 0% 50%;}
}

.audioFile {
    width: 0;
    height: 0;
    visibility: hidden;
}

//Header.js

.headerIconColor {
    fill: ${({theme})=>theme.mainOne};
}
.grey {
    opacity: .2;
}

.switch, .soundIconVector {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}


//QuizOne.js
.quizSlidesAni-enter {
    opacity: 0;
    transform: scale(0.9);
  }

.quizSlidesAni-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 100ms, transform 100ms;
  }

.quizSlidesAni-exit {
    opacity: 1;
  }

.quizSlidesAni-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
  }

//QuizOne Intro
.globeIcon {
    fill: ${({theme})=>theme.titleOne};
    animation: turn 4s linear infinite;
}

@keyframes turn {    
    0% 
        {transform: rotate(0deg);}
    50%
        {transform: rotate(180deg);}
    
    100% 
        {transform: rotate(360deg);}
}

.exampleQuizColor {
    background-color: ${({theme})=>theme.main};
    color: ${({theme})=>theme.titleTwo};
    &:hover .exampleCorrectColor {
        color: ${({theme})=>theme.titleOne};
    }
}

//QuizOne Slides

.backButton {
    fill: ${({theme})=>theme.mainOne};
    background: none;
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}
.timelineButton {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}
label {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}

.stamp {
    border: 2px solid ${({theme})=>theme.titleTwo};
    cursor: url(${({theme})=>theme.cursorAutoTwo}), auto;
    transition: .3s ease-in-out;
    :hover {
        border: 2px solid ${({theme})=>theme.titleOne};
    }
}
.stampChecked {
    background-color: ${({theme})=>theme.titleTwo};
    transition: .3s ease-in-out;
}

.wrong {
    background-color:${({theme})=>theme.wrongRed};
    color: ${({theme})=>theme.paraTwo};
    border: none;
    transition: .3s ease-in;
}

.correct {
    background-color:${({theme})=>theme.correctGreen};
    color: ${({theme})=>theme.paraTwo};
    border: none;
    transition: .3s ease-in;
}

.explanation {
    color: ${({theme})=>theme.paraOne};
    border: ${({theme})=>theme.titleOne} dashed 2px;
}

//StoryTwo.js

.audioTimelineContainer {
    background-color: ${({theme})=>theme.eOne};
        .audioPlayerIcon {
            fill: ${({theme})=>theme.eTwo};
            cursor: url(${({theme})=>theme.cursorPoint}), auto;
        }
}

.mark {
    background: ${({theme})=>theme.eTwo};
    cursor: url(${({theme})=>theme.cursorAutoTwo}), auto;
        :hover {
            background: ${({theme})=>theme.titleThree};
        }


}

.transcript {
    border: 10px solid;
    border-image: url(${({theme})=>theme.outline}) 31 round;
}

.transcriptText {
    color: ${({theme})=>theme.titleThree};
}

.progressBar {
    background: ${({theme})=>theme.titleThree};
}
.filler {
    background:  ${({theme})=>theme.eTwo};
}


.outerCircle {
    background: ${({theme})=>theme.titleThree}
}
.innerCircle {
    background: ${({theme})=>theme.eTwo}
}

.tooltip {
    background: ${({theme})=>theme.titleThree};
    color: ${({theme})=>theme.paraOne};
}


//InteractOne.js

.padOne {
    fill: ${({theme})=>theme.eOne};
}

.quoteMain {
    color:  ${({theme})=>theme.paraThree};
    span{
        animation: flow 5s ease-in-out infinite;
        background: linear-gradient(-60deg, ${({theme})=>theme.titleOne},${({theme})=>theme.titleTwo}, ${({theme})=>theme.titleOne}, ${({theme})=>theme.titleTwo});
        background-size: 300%;
        background-clip: text;
        -webkit-background-clip: text;
        text-fill-color: transparent;
        -webkit-text-fill-color: transparent;
    }
}

//target Safari
@media not all and (min-resolution:.001dpcm) { 
    @media {
        .quoteMain { 
        span{
            display: inline-block;
        }
        }
    }
}

.quoteAuthor {
    color:  ${({theme})=>theme.paraThree}
}


//QuizTwo.js

.wrong-quizTwo {
    background-color:${({theme})=>theme.wrongRed};
    color: ${({theme})=>theme.paraTwo};
    transition: .3s ease-in;
}

.correct-quizTwo {
    background-color:${({theme})=>theme.correctGreen};
    color: ${({theme})=>theme.paraTwo};
    transition: .3s ease-in;
}
.storyTwoAnswers {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}

//interactTwo.js

 
.euphe {
    color: ${({theme})=>theme.titleThree};
    span {
        border: solid 10px;
        border-image: url(${({theme})=>theme.outline}) 31 round;
        animation: flow 5s ease-in-out infinite;
        background: linear-gradient(-60deg, ${({theme})=>theme.titleOne},${({theme})=>theme.titleTwo}, ${({theme})=>theme.titleOne}, ${({theme})=>theme.titleTwo});
        background-size: 300%;
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
            :hover{
                border-image: url(${({theme})=>theme.outlineTwo}) 31 round;
            }
    }
    
}

//interactThree.js

.sketchTwo {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}
.endoText {
    color: ${({theme})=>theme.paraThree};
        span {
            color: ${({theme})=>theme.eTwo};
            }
}

.ripple {
    width: 60%;
    height: 60%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    visibility: hidden;
}


.show {
    visibility: visible;
}


.ripple div {
    position: absolute;
    border: 4px solid ${({theme})=>theme.titleOne};
    opacity: .8;
    border-radius: 50%;
    animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

.ripple div:nth-child(2) {
    animation-delay: -0.8s;
}
  
@keyframes lds-ripple {
    0% {
        width: 45vmin;
        height: 45vmin;
        opacity: .8;
    }
    100% {
        width: 60vmin;
        height: 60vmin;
        opacity: 0;
    }
}

//storyOne.js
.storyOneIndicate {
    background-color: ${({theme})=>theme.titleThree}
}

.storyContainer {
    background: ${({theme})=>theme.main};
}

.storyQuestionContainer {
    border: 10px solid;
    border-image: url(${({theme})=>theme.outlineTwo}) 30 round;
    input:checked ~ .storyQuestion {
        background: ${({theme})=>theme.titleThree};
        color:  ${({theme})=>theme.paraTwo};
        transition: all .3s ease-in;
    }
    &::-webkit-scrollbar {
        width: 20px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({theme})=>theme.titleThree};
        border-radius: 10px;
        width: 20px;
        border: 5px solid transparent;
        background-clip: padding-box;
    }
}


.storyAnswerContainer {
    border: 10px solid;
    border-image: url(${({theme})=>theme.outline}) 30 round;
    &::-webkit-scrollbar {
        width: 20px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({theme})=>theme.eTwo};
        border-radius: 10px;
        width: 20px;
        border: 5px solid transparent;
        background-clip: padding-box;
    }
}

.storyQuestion {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
    font-family: bely;
    font-size: 1.2rem;
    color: ${({theme})=>theme.eTwo};
    border: 2px solid ${({theme})=>theme.titleThree};
}

.storyAnswerText {
    color: ${({theme})=>theme.paraThree};
    font-family: bely;
    font-size: 1.5rem;
    font-weight: 20;
}

//Comment.js

.typeBox {
    border: none;
    background: ${({theme})=>theme.eOne};
    color: ${({theme})=>theme.paraOne};
    // box-shadow: inset 0 0 10px ${({theme})=>theme.paraThree};
    // border: 2px solid ${({theme})=>theme.titleTwo};
}

.commentPrompt {
    color: ${({theme})=>theme.paraOne};
}
.commentUnderline {
    border-top: 1px solid ${({theme})=>theme.paraOne};
}

textarea::placeholder, input::placeholder  {
    color: ${({theme})=>theme.paraThree};
    opacity: .6;
    font-family: poynterGothicText, sans-serif;
    // font-size: 2vmin;
    font-size: 1rem;
    line-height: 1.5
}

.userName {
    color: ${({theme})=>theme.paraOne}
}

.commentTitle {
    border: ${({theme})=>theme.titleOne} dashed 2px;
    color: ${({theme})=>theme.paraOne};
}

.submitColor {
    stroke: ${({theme})=>theme.paraThree};
}

.submitButton {
    cursor: url(${({theme})=>theme.cursorPoint}), auto;
}

.greyBackground {
    background: ${({theme})=>theme.eOne};
}

//initial attempt to style audio subtitles
// video::cue {
//     color: ${({theme})=>theme.titleThree};
//     font-size: 2rem;
//     background: white;
//     border: solid 2px yellow !important;
// }
// video::-webkit-media-text-track-display-backdrop {
//     background-color: transparent !important;
//   }

// video::-webkit-media-text-track-container {
//     -webkit-transform: translateY(-30%) !important;
//     transform: translateY(-30%) !important;
//    }

// video::-webkit-media-text-track-background {
// }

// video::-webkit-media-text-track-display {
//     display: flex !impoortant;
//     margin-bottom: 40% !important;
//     margin-left: 10% !important;
//     border: 1px red solid;
//     border-radius: 0 !important;
//     background: none !important;
//     width: 80% !important;
// }

`
